module.exports = __webpack_public_path__ + "static/media/my_location.ea82ff91.svg";